/**
 * BDU Monogram — interlocked "BDU" mark in Cormorant Garamond serif
 * Sits inside a thin gold circle. Configurable size + color.
 */
export default function Monogram({ size = 40, tone = "#D4AF37", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      aria-label="Black Dollars United monogram"
      role="img"
    >
      {/* Outer ring */}
      <circle cx="50" cy="50" r="46" fill="none" stroke={tone} strokeWidth="1.25" />
      {/* Inner accent ring */}
      <circle cx="50" cy="50" r="42" fill="none" stroke={tone} strokeOpacity="0.35" strokeWidth="0.6" />

      {/* Overlapping monogram letters */}
      <text
        x="50"
        y="63"
        textAnchor="middle"
        fontFamily='"Cormorant Garamond", "Playfair Display", serif'
        fontSize="46"
        fontWeight="500"
        letterSpacing="-6"
        fill={tone}
        style={{ fontStyle: "italic" }}
      >
        BDU
      </text>

      {/* Tiny gold dots — anchor points */}
      <circle cx="50" cy="12" r="1.2" fill={tone} />
      <circle cx="50" cy="88" r="1.2" fill={tone} />
    </svg>
  );
}
